import React, { memo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { updateDashboard } from '@components/settings/actions';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import './settings.scss';

const Dashboard = () => {
  const { global: { dashboard } } = useSelector(state => state.config);
  const dispatch = useDispatch();

  const onChange = event => dispatch(updateDashboard(event.target.value));

  return (
    <div styleName="settings-form-container">
      <div styleName="title">
        <div styleName="text">Dashboard</div>
      </div>
      <div styleName="hint">
        Switch between the old and new dashboard design.
      </div>
      <div styleName="form">
        <FormControl component="fieldset">
          <RadioGroup aria-label="dashboard" name="dashboard" value={dashboard} onChange={onChange}>
            <FormControlLabel value="old" control={<Radio color="primary" />} label="Old Dashboard Design" />
            <FormControlLabel value="new" control={<Radio color="primary" />} label="New Dashboard Design" />
          </RadioGroup>
        </FormControl>
      </div>
    </div>
  );
};

export default memo(Dashboard);

